import React, { useEffect} from 'react';
import styles from './increaseLimitSuccessModal.module.css';
import PropTypes from 'prop-types';

export const IncreaseLimitSuccessModal = ({onSuccess}) => {

  useEffect(() => {
    onSuccess();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
      Limit increase request submitted
      </div>
      <div className={styles.content}>
        <div>Thank you for your Cash Flow Facility Limit Increase application.
        We will be in touch, if there is anything we need to clarify.</div>
      </div>
    </div>
  );
};

IncreaseLimitSuccessModal.propTypes = {
  onSuccess: PropTypes.func,
  onClick: PropTypes.func
};